<template>
    <div class="sixth" :style="height">
        <header>
            <img src="../assets/logo.svg">

                <div class="subtitle">
                    <span>{{brandName}}</span>
                    <span>  >  </span>
                    <span>{{area}}</span>
                    <span>  >  </span>
                    <span>{{channel}}</span>
                    <span>  >  </span>
                </div>

        </header>
        <div class="chart">
            <h2 class="title">Performance</h2>
            <div class="chartBox">
                <div class="left">
                    <p class="subtitle">共触达目标人群 <span>Total Reach</span></p>
                    <p class="subtitle-p">{{person}} <span>人</span></p>
                    <div class="progress" >
                        <div class="circle-box" :key="index" v-for="(item,index) in reach">
                            <div class="vd-demo__block vd-demo__block-2">
                                <vm-progress type="circle" :percentage="item.circle.num" :stroke-width="13" :stroke-color="item.circle.color"
                                             :track-color="'#323854'" :width="160" :show-text="false"></vm-progress>
                            </div>
                            <div class="circle-text">
                                <p>{{item.text[0]}}<span>{{item.text[1]}}  </span><span>{{item.text[2]}} </span></p>
                            </div>
                        </div>



                    </div>
                </div>
            </div>
            <footer>
                <div>
                    <div class="prev">
                        <router-link to="/fourth"> << prev </router-link>
                    </div>
                    <div class="step"><span>4/4</span></div>
                    <div class="continue"><span><router-link to="/seventh"><button clickMusic='true'>Look at the score</button></router-link></span>
                    </div>
                </div>
            </footer>
        </div>
    </div>
</template>
<style>
    .sixth {
        background: #1e253d;
    }

    .sixth .chart {
        margin: 0 5%;
    }

    .sixth .title {
        color: #fff;
        font-size: 40px;
        margin:5% 0 3% 0;
        text-align: center;
    }

    .chartBox {
        display: flex;
        justify-content:center;
    }

    .chartBox .left {
        width: 60%;
        background: #262d48;
    }

    .chartBox .subtitle {
        background: #262d48;
        text-align: center;
        padding: 30px 0 10px;
        color: #fff;
        border-radius: 5px;
        font-size: 20px;
        font-weight: bold;
    }

    .chartBox .subtitle span{
        font-size: 14px;
        display: block;
        font-weight: 500;
    }

    .chartBox .subtitle-p{
        font-size: 36px;
        color: #f37e70;
        text-align: center;
        font-weight: bold;
    }
    .chartBox .subtitle-p span{
        font-size:14px;
        color:#fff;

    }
    .progress {
        display: flex;
        margin:30px 0;
        padding: 3% 4%;
        background: #262d48;
        border-radius: 5px;
        justify-content:center;

    }

    .circle-box {
        position: relative;
        min-width: 160px;
        margin: 0 5%;
        height: 160px;
    }

    .circle-text {
        position: absolute;
        color: #fff;
        top: 22%;
        text-align: center;
        width:160px;
    }

    .circle-text p {
        font-size: 36px;
        font-weight: bold;
    }

    .circle-text span {
        display: block;
        text-align: center;
        font-size: 16px;
    }

    .circle-text p span:last-child{font-size: 12px;}

    .line-box{width: 60%;margin-left: 8%;}
    .line{position: relative;padding: 17px 0}
    .line .left{float: left;width: 20%;color: #fff;font-size: 12px;}
    .line .right{float: right;width: 76%;color: #fff}

    .line .vm-progress__text {
       color: #fff;  font-size: 12px;
    }

    .line .vm-progress-bar__inner{
        background: linear-gradient(to right, #f89b7d, #f53f80);
    }


    .sixth  footer div .continue button{width: 60%}

    @keyframes animate-positive {
        0% { width:0%; }
    }

    @keyframes animate-circle{
        0% { stroke-dashoffset:288.712px; }
    }

</style>

<script>

    import dataAll from '../assets/data';
    import link from '../assets/link';



    export default {
        name: 'sixth',
        data () {
            return {
                brandName: 'Clear',
                area: '',
                channel:'',
                radioVal1: [
                    {text: "大卖场", val: "bigStore"},
                    {text: "便利店", val: "convenienceStore"},
                    {text: "屈臣氏", val: "Watsons"}
                ],
                radioVal: [
                    {text: "楼宇电视广告位", val: "building"},
                    {text: "公交站广告位", val: "transit"},
                    {text: "地铁站广告位", val: "metro"},
                    {text: "LBS Digital", val: "Lbs"}
                ],
                reach:[],
                height:{
                    height:''
                },
                person:0
            }
        },
        methods: {
            readData(){
                this.brandName = sessionStorage.getItem("BrandName");
                let area1 = sessionStorage.getItem("area");
                for (let x of this.radioVal1) {
                    if (x.val == area1) {
                        this.area = x.text
                    }
                };

                let channel1 = sessionStorage.getItem("channel");
                var c=channel1.split(",");

                let a =[];
                for (let x =0;x< c.length;x++) {
                    for(let u of this.radioVal){
                        if(c[x] == u.val){
                            a.push(u.text)
                        }
                    }
                };

                this.channel=a.join("、");

                let data = dataAll;
                let channelData ;
                console.log(data);
                for(let x of data.brand){
                   if(x.brandName == this.brandName){
                       for(let y of x.area){
                           if(y.area == area1){
                               channelData =y
                           }
                       }
                   }
                }

                for(let z of channelData.channel){
                    let u = this.compareArr(c,z.channel);
                    console.log(u)
                    if(u){
                        this.person = z.person
                        this.reach = z.reach;
                        sessionStorage.setItem("rank",z.rank);
                    }
                }



            },
            compareArr(a,b){
                let IsCompare = 0;
                let Compare = false;

                for (var i = 0; i < a.length; i++) {
                    for(var f = 0;f< b.length;f++){
                        if(a[i]==b[f]){
                            IsCompare = IsCompare+1
                        }
                    }
                }

                if(IsCompare==a.length){
                    Compare = true
                }else{
                    Compare = false
                }

                return Compare

            }

        },
        created(){
            this.height.height=window.innerHeight+'px';
            this.readData();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/sixth.vue